import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewsFeedScreenComponent } from './components/news-feed-screen/news-feed-screen.component';

const routes: Routes = [
  {
    path: '',
    component: NewsFeedScreenComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewsFeedRoutingModule {}
